import { createAuthClient } from "better-auth/react";
import { magicLinkClient } from "better-auth/client/plugins";

export const authClient = createAuthClient({
  plugins: [magicLinkClient()],
  basePath: "/api/external/auth",
});

export const { signIn, signOut, useSession } = authClient;
